var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',{staticClass:"top-title"},[_vm._v(_vm._s(_vm.$t("top.title")))]),_c('p',[_vm._v(_vm._s(_vm.$t("top.description")))]),_c('router-link',{attrs:{"to":"preview"}},[_c('Button',{attrs:{"shape":"circle","long":""}},[_vm._v(_vm._s(_vm.$t("top.preview")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }